export default __webpack_public_path__ + "static/growingBusinessBg-9ab228a01066e886cda0f849f03c488f.png";